import { OTP_DELIVERY_CHANNELS, REDUX_STORE_SLICES } from '../../services/exports/Constants';
import { resolveDefaultOtpChannel, resolveOtpChannels } from '../../utils/otp';
import useStore from '../store/useStore';

interface OtpChannels {
  // Channels the company's provider actually accepts; anything else is a 422.
  channels: OTP_DELIVERY_CHANNELS[];
  // Channel to pre-select, guaranteed to be one of `channels`.
  defaultChannel: OTP_DELIVERY_CHANNELS;
}

/**
 * Single source of truth for which OTP channels the current shop offers. Both the
 * channel chooser and the flows that send the code read it, so the pre-selected
 * channel can never be one the backend would reject.
 */
export default function useOtpChannels(): OtpChannels {
  const { company } = useStore<REDUX_STORE_SLICES.INITIAL_DATA>(REDUX_STORE_SLICES.INITIAL_DATA);

  const channels = resolveOtpChannels(company?.service_provider?.otp_delivery_channels);

  return { channels, defaultChannel: resolveDefaultOtpChannel(channels) };
}
